import { render, staticRenderFns } from "./add-solution.vue?vue&type=template&id=0f0a4d44&"
import script from "./add-solution.vue?vue&type=script&lang=js&"
export * from "./add-solution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports